module.exports = __webpack_public_path__ + "img/store-2-used.215eacb6.svg";